import { InjectionToken } from '@angular/core';
// import { ClassType } from '../serialization/class-transformer/ClassTransformer';

export const SERIALIZATION_WEBWORKER_FACTORY = new InjectionToken<() => Worker>(
    'serialization.worker'
);
